module.exports = __webpack_public_path__ + "images/header-logo-spirit-loading.ac67523ad250b82d5ab7.gif";